/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import * as React from 'react';

import { IObrienNavContainerConfig, IObrienNavContainerProps } from './obrien-nav-container.props.autogenerated';


export interface IObrienNavContainerViewProps extends IObrienNavContainerProps<IObrienNavContainerConfig> {
    ob1categories: React.ReactNode[];
    Obrien1List: IModuleProps;
    Obrien1ListItem: INodeProps;
    ob2categories: React.ReactNode[];
    Obrien2List: IModuleProps;
    Obrien2ListItem: INodeProps;
    ob3categories: React.ReactNode[];
    Obrien3List: IModuleProps;
    Obrien3ListItem: INodeProps;
    ob4categories: React.ReactNode[];
    Obrien4List: IModuleProps;
    Obrien4ListItem: INodeProps;
    ob5categories: React.ReactNode[];
    Obrien5List: IModuleProps;
    Obrien5ListItem: INodeProps;
    ob6categories: React.ReactNode[];
    Obrien6List: IModuleProps;
    Obrien6ListItem: INodeProps;
    ob7categories: React.ReactNode[];
    Obrien7List: IModuleProps;
    Obrien7ListItem: INodeProps;
    ob8categories: React.ReactNode[];
    Obrien8List: IModuleProps;
    Obrien8ListItem: INodeProps;
    ob9categories: React.ReactNode[];
    Obrien9List: IModuleProps;
    Obrien9ListItem: INodeProps;
    ob10categories: React.ReactNode[];
    Obrien10List: IModuleProps;
    Obrien10ListItem: INodeProps;
    mg1categories: React.ReactNode[];
    Margaritaville1List: IModuleProps;
    Margaritaville1ListItem: INodeProps;
    mg2categories: React.ReactNode[];
    Margaritaville2List: IModuleProps;
    Margaritaville2ListItem: INodeProps;
    mg3categories: React.ReactNode[];
    Margaritaville3List: IModuleProps;
    Margaritaville3ListItem: INodeProps;
    mg4categories: React.ReactNode[];
    Margaritaville4List: IModuleProps;
    Margaritaville4ListItem: INodeProps;
    spcategories: React.ReactNode[];
    SupportList: IModuleProps;
    SupportListItem: INodeProps;
    //
    //
    //obrienLink: string;
    //margaritavilleLink: string;
    hydroslideLink: string;
    saleLink: string;
    //supportLink: string;
    teamLink: string;
}


/**
 *
 * ObrienNavContainer component.
 * @extends {React.PureComponent<IObrienNavContainerProps<IObrienNavContainerConfig>>}
 */
 class ObrienNavContainer extends React.PureComponent<IObrienNavContainerProps<IObrienNavContainerConfig>> {
    public render(): JSX.Element | null {
        const { config } = this.props;

        //const ObrienLink = config.obrienLink ? config.obrienLink : 'No Link Provided';
        //const MargaritavilleLink = config.margaritavilleLink ? config.margaritavilleLink : 'No Link Provided';
        const HydroslideLink = config.hydroslideLink ? config.hydroslideLink : 'No Link Provided';
        const SaleLink = config.saleLink ? config.saleLink : 'No Link Provided';
        //const SupportLink = config.supportLink ? config.supportLink : 'No Link Provided';
        const TeamLink = config.teamLink ? config.teamLink : 'No Link Provided';

        if (!this.props.slots || !this.props.slots.obrienSlot1 || this.props.slots.obrienSlot1.length === 0) {
            this.props.context.telemetry.error('obrienSlot1 is empty, module wont render');
            return null;
        }
        const viewprops = {
            ...this.props,
            //obrienLink: ObrienLink,
            //margaritavilleLink: MargaritavilleLink,
            hydroslideLink: HydroslideLink,
            saleLink: SaleLink,
            //supportLink: SupportLink,
            teamLink: TeamLink,
            ob1categories: this.props.slots.obrienSlot1,
            Obrien1List: {
                moduleProps: this.props,
                className: classnames('obrien-nav-container__list', this.props.config.className),
                tag: 'ul'
            },
            Obrien1ListItem: {
                className: classnames('obrien-nav-container__list-item', this.props.config.className),
                tag: 'li'
            },
            ob2categories: this.props.slots.obrienSlot2,
            Obrien2List: {
                moduleProps: this.props,
                className: classnames('obrien-nav-container__list', this.props.config.className),
                tag: 'ul'
            },
            Obrien2ListItem: {
                className: classnames('obrien-nav-container__list-item', this.props.config.className),
                tag: 'li'
            },
            ob3categories: this.props.slots.obrienSlot3,
            Obrien3List: {
                moduleProps: this.props,
                className: classnames('obrien-nav-container__list', this.props.config.className),
                tag: 'ul'
            },
            Obrien3ListItem: {
                className: classnames('obrien-nav-container__list-item', this.props.config.className),
                tag: 'li'
            },
            ob4categories: this.props.slots.obrienSlot4,
            Obrien4List: {
                moduleProps: this.props,
                className: classnames('obrien-nav-container__list', this.props.config.className),
                tag: 'ul'
            },
            Obrien4ListItem: {
                className: classnames('obrien-nav-container__list-item', this.props.config.className),
                tag: 'li'
            },
            ob5categories: this.props.slots.obrienSlot5,
            Obrien5List: {
                moduleProps: this.props,
                className: classnames('obrien-nav-container__list', this.props.config.className),
                tag: 'ul'
            },
            Obrien5ListItem: {
                className: classnames('obrien-nav-container__list-item', this.props.config.className),
                tag: 'li'
            },
            ob6categories: this.props.slots.obrienSlot6,
            Obrien6List: {
                moduleProps: this.props,
                className: classnames('obrien-nav-container__list', this.props.config.className),
                tag: 'ul'
            },
            Obrien6ListItem: {
                className: classnames('obrien-nav-container__list-item', this.props.config.className),
                tag: 'li'
            },
            ob7categories: this.props.slots.obrienSlot7,
            Obrien7List: {
                moduleProps: this.props,
                className: classnames('obrien-nav-container__list', this.props.config.className),
                tag: 'ul'
            },
            Obrien7ListItem: {
                className: classnames('obrien-nav-container__list-item', this.props.config.className),
                tag: 'li'
            },
            ob8categories: this.props.slots.obrienSlot8,
            Obrien8List: {
                moduleProps: this.props,
                className: classnames('obrien-nav-container__list', this.props.config.className),
                tag: 'ul'
            },
            Obrien8ListItem: {
                className: classnames('obrien-nav-container__list-item', this.props.config.className),
                tag: 'li'
            },
            ob9categories: this.props.slots.obrienSlot9,
            Obrien9List: {
                moduleProps: this.props,
                className: classnames('obrien-nav-container__list', this.props.config.className),
                tag: 'ul'
            },
            Obrien9ListItem: {
                className: classnames('obrien-nav-container__list-item', this.props.config.className),
                tag: 'li'
            },
            ob10categories: this.props.slots.obrienSlot10,
            Obrien10List: {
                moduleProps: this.props,
                className: classnames('obrien-nav-container__list', this.props.config.className),
                tag: 'ul'
            },
            Obrien10ListItem: {
                className: classnames('obrien-nav-container__list-item', this.props.config.className),
                tag: 'li'
            },
            mg1categories: this.props.slots.margaritavilleSlot1,
            Margaritaville1List: {
                moduleProps: this.props,
                className: classnames('obrien-nav-container__list', this.props.config.className),
                tag: 'ul'
            },
            Margaritaville1ListItem: {
                className: classnames('obrien-nav-container__list-item', this.props.config.className),
                tag: 'li'
            },
            mg2categories: this.props.slots.margaritavilleSlot2,
            Margaritaville2List: {
                moduleProps: this.props,
                className: classnames('obrien-nav-container__list', this.props.config.className),
                tag: 'ul'
            },
            Margaritaville2ListItem: {
                className: classnames('obrien-nav-container__list-item', this.props.config.className),
                tag: 'li'
            },
            mg3categories: this.props.slots.margaritavilleSlot3,
            Margaritaville3List: {
                moduleProps: this.props,
                className: classnames('obrien-nav-container__list mg3', this.props.config.className),
                tag: 'ul'
            },
            Margaritaville3ListItem: {
                className: classnames('obrien-nav-container__list-item mg3', this.props.config.className),
                tag: 'li'
            },
            mg4categories: this.props.slots.margaritavilleSlot4,
            Margaritaville4List: {
                moduleProps: this.props,
                className: classnames('obrien-nav-container__list', this.props.config.className),
                tag: 'ul'
            },
            Margaritaville4ListItem: {
                className: classnames('obrien-nav-container__list-item', this.props.config.className),
                tag: 'li'
            },
            spcategories: this.props.slots.supportSlot,
            SupportList: {
                moduleProps: this.props,
                className: classnames('obrien-nav-container__list', this.props.config.className),
                tag: 'ul'
            },
            SupportListItem: {
                className: classnames('obrien-nav-container__list-item', this.props.config.className),
                tag: 'li'
            }
        };

       

        return this.props.renderView(viewprops) as React.ReactElement;
        
    }
}

export default ObrienNavContainer;
